var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sticky',{attrs:{"type":_vm.stickyTypeTop,"exclude-header":true}},[_c('div',{staticClass:"search-contact-lens-filter-button",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }